import gsap from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { SplitText } from 'gsap/all';
import { Maths } from '../_app/cuchillo/utils/Maths';

gsap.registerPlugin(SplitText);

class ScrollItem__BlockReviews extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.items = new SplitText(GetBy.class('text', this.item)[0], { type: 'words', wordsClass: 'word-child' }).words;
        this.totalItems = this.items.length;
        this.inc = 1 / this.totalItems;
    }

    drawHook() {
        this.animationText()
    }

    animationText() {        
        //SPANS
        
        const progress = this.progress;
        const norm = Maths.precission(Maths.normalize(.5, .3, progress));

        let p0 = 0;
        let p1 = this.inc;


        for (let i = 0; i < this.totalItems; i++) {
           
            const o = Math.max(.2, Maths.normalize(p1, p0, norm));

            this.items[i].style.opacity = o;


            p0 = p1;
            p1 = p1 + this.inc;
        }
  }

}

Scroll._registerClass('BlockReviews', ScrollItem__BlockReviews);

export default ScrollItem__BlockReviews;
